import { render, staticRenderFns } from "./PartnerClassesForm.vue?vue&type=template&id=71d5e549&scoped=true"
import script from "./PartnerClassesForm.vue?vue&type=script&lang=js"
export * from "./PartnerClassesForm.vue?vue&type=script&lang=js"
import style0 from "./PartnerClassesForm.vue?vue&type=style&index=0&id=71d5e549&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d5e549",
  null
  
)

export default component.exports